import React, {useState, useEffect} from "react";
import {useParams, useNavigate} from 'react-router-dom';
import {createHashHistory} from 'history';
import {
	getProject, 
	getProjectAncestry, 
	getLevelProjects, 
	handleLevelProjectChange, 
	saveProject
} from "./apiService";
import {
	getProjects as getBigtimeProjects,
	getTasks as getBigtimeTasks
} from "./bigtimeService";

const EditProject = (props) => {
	const [error, setError] = useState(null);
	const [isLoaded, setIsLoaded] = useState(false);
	const [project, setProject] = useState(null);
	const [levelProjects, setLevelProjects] = useState([]);
	const [bigtimeProjects, setBigtimeProjects] = useState([]);
	const [bigtimeTasks, setBigtimeTasks] = useState([]);
	const [inputs, setInputs] = useState({});
	const {projectIdParam} = useParams();
	const navigate = useNavigate();
	const history = createHashHistory();

	console.log('EditProject', props);
	useEffect(() => {
		console.log('EditProject.useEffect', projectIdParam);
		let projectId = projectIdParam;

		if(projectIdParam == null) {
			setIsLoaded(true);
			setProject({id: null});
			getLevelProjects([]).then(levelProjects => {
				setLevelProjects(levelProjects);
			});
			return;
		}

		loadBigtimeProjects();
		getProject(projectId).then(
			data => {
				console.log('getProject data', data);
				if(data.status === 401) {
					navigate('/login', {replace: true});
					return;
				}
				if(data.status !== 200) {
					setError(data);
					setIsLoaded(true);
					return;
				}
				console.log("call setProject", data.result);
				setProject(data.result);
				setInputs({
					code: data.result.code,
					bigtime_project_id: data.result.bigtimeProjectId,
					bigtime_task_id: data.result.bigtimeTaskId,
					bigtime_description: data.result.bigtimeDescription,
					minimum_billable_hours: data.result.minimumBillableHours,
					round_daily_hours_to: data.result.roundDailyHoursTo
				});
				setIsLoaded(true);

				loadBigtimeTasks(data.result.bigtimeProjectId);

				getProjectAncestry(projectId).then(
					data => {
						console.log('getProjectAncestry data', data);
						if(data.status === 401) {
							navigate('/login', {replace: true});
							return;
						}
						if(data.status !== 200) {
							setIsLoaded(true);
							setError(data);
							return;
						}
						getLevelProjects(data.result).then(levelProjects => {
							setLevelProjects(levelProjects);
						});
					},
					error => {
						console.error('error object', error);
						setError(data);
					}
				);
			},
			error => {
				console.error('error object', error);
				setError(error);
				setIsLoaded(true);
			}
		);
	}, [projectIdParam, navigate]);

	const loadBigtimeProjects = () => {
		let bigtimeToken = window.localStorage.getItem('bigtime-token');
		if(bigtimeToken != null) {
			getBigtimeProjects().then(bigtimeProjects => {
				setBigtimeProjects(bigtimeProjects);
			},
			reason => {
				console.error(reason);
				setBigtimeProjects([]);
			});
		}
		else {
			setBigtimeProjects([]);
		}
	};
	const loadBigtimeTasks = bigtimeProjectId => {
		if((bigtimeProjectId || '') === '') {
			setBigtimeTasks([]);
			return;
		}
		let bigtimeToken = window.localStorage.getItem('bigtime-token');
		if(bigtimeToken == null) {
			setBigtimeTasks([]);
			return;
		}
		getBigtimeTasks(bigtimeProjectId).then(tasks => {
			let filteredTasks = [];
			for(let task of tasks) {
				if(task.AssignmentNames.indexOf('Steve Schafer') >= 0) {
					filteredTasks.push(task);
				}
			}
			setBigtimeTasks(filteredTasks);
		},
		reason => {
			console.error(reason);
			setBigtimeTasks([]);
		});
};

	console.log('EditProject render', isLoaded, error, project);

	if(error) {
		return <div>Error: {error.message}</div>;
	}

	if(!isLoaded || project == null) {
		console.log('not yet loaded: ', isLoaded, project);
		return <div>Loading...</div>;
	}

	const handleChange = e => {
		const name = e.target.name;
		const value = e.target.value;
		setInputs(values => ({...values, [name]: value}));
	// project == null ? '' : project.code
};

	const handleCancel = e => {
		history.back();
	};

	const handleSubmit = e => {
		console.log('EditProject handleSubmit', e);
		e.preventDefault();
		let data = {
			code: inputs.code,
			bigtimeProjectId: +inputs.bigtime_project_id,
			bigtimeTaskId: +inputs.bigtime_task_id,
			bigtimeDescription: inputs.bigtime_description,
			minimumBillableHours: +inputs.minimum_billable_hours,
			roundDailyHoursTo: +inputs.round_daily_hours_to
		};
		if(project) {
			data.id = project.id;
		}
		let  lastProjectId = null;
		for(let levelProject of levelProjects) {
			if(levelProject.id) {
				lastProjectId = levelProject.id;
			}
		}
		if(lastProjectId != null) {
			data.parentId = lastProjectId;
		}
		saveProject(data).then(
			data => {
				console.log('saveProject data', data);
				if(data.status !== 200) {
					alert(data.message);
					return;
				}
				history.back();
			},
			error => {
				alert(error.message);
				console.error('error object', error);
			}
		);
	};

	let projectRows = [];
	for(let projectObject of levelProjects) {
		console.log('projectObject', projectObject);
		let name = `project ${projectRows.length}`;
		let key = `${projectRows.length}`;
		projectRows.push((
			<select value={projectObject.id || ''} 
				onChange={e => {
					handleLevelProjectChange(e, levelProjects).then(levelProjects => {
						setLevelProjects(levelProjects)
					})
				}} 
				name={name}
				key={key}>
				<option value="">Select one...</option>
				<option value="add">Add project...</option>
			{
				projectObject.selectionList.map(projectSelection => {
					return <option value={projectSelection.id} key={projectSelection.id}>
						{projectSelection.code}</option>
				})
			}	
			</select>
		));
	}
	console.log('projectRows', projectRows);

	return (
		<>
		<h1>{project.id == null ? 'Add Project' : `Edit Project ${project.id}`}</h1>
		<form onSubmit={handleSubmit}>
			<div><label>Project Name</label></div>
			<div>
				<input type="text" name="code" id="code"
					value={inputs.code || ''}
					onChange={handleChange} />
			</div>
			<div>
				<div>Bigtime Project Id</div>
				<div>
				{
					bigtimeProjects.length > 0 ?
						<select value={inputs.bigtime_project_id || ''}
								onChange={e => {
									loadBigtimeTasks(e.target.value);
									handleChange(e);
								}} name="bigtime_project_id" id="bigtime_project_id">
							<option value="">?Select one...</option>
							{
								bigtimeProjects.map(bigtimeProject => {
									return <option value={bigtimeProject.SystemId} key={bigtimeProject.SystemId}>
										{bigtimeProject.DisplayName}</option>
								})
							}
						</select>
					:
						<input type="text" name="bigtime_project_id" id="bigtime_project_id"
							value={inputs.bigtime_project_id || ''}
							onChange={e => {
								loadBigtimeTasks(e.target.value);
								handleChange(e);
							}} />
				}
				</div>
			</div>
			<div>
				<div>Bigtime Task Id</div>
				<div>
				{
					bigtimeTasks.length > 0 ?
						<select value={inputs.bigtime_task_id || ''}
								onChange={handleChange} name="bigtime_task_id" id="bigtime_task_id">
							<option value="">?Select one...</option>
							{
								bigtimeTasks.map(bigtimeTask => {
									return <option value={bigtimeTask.TaskSid} key={bigtimeTask.TaskSid}>
										{bigtimeTask.TaskNm}</option>
								})
							}
						</select>
					: 
					<input type="text" name="bigtime_task_id" id="bigtime_task_id"
						value={inputs.bigtime_task_id || ''}
						onChange={handleChange} />
				}
				</div>
			</div>
			<div>
				<div>Bigtime Description</div>
				<div>
					<input type="text" name="bigtime_description" id="bigtime_description"
						value={inputs.bigtime_description || ''}
						onChange={handleChange} />
				</div>
			</div>
			<div>
				<div>Minimum Billable Hours</div>
				<div>
					<input type="text" name="minimum_billable_hours" id="minimum_billable_hours"
						value={inputs.minimum_billable_hours || ''}
						onChange={handleChange} />
				</div>
			</div>
			<div>
				<div>Round Daily Hours To</div>
				<div>
					<input type="text" name="round_daily_hours_to" id="round_daily_hours_to"
						value={inputs.round_daily_hours_to || ''}
						onChange={handleChange} />
				</div>
			</div>
			<div>
			Parent Project
			</div>
			<div>
			{projectRows}
			</div>
			<button type="submit">Submit</button>
			<button type="button" onClick={handleCancel}>Cancel</button>
		</form>
		</>
	);
}

export default EditProject;